<template>
  <div class="banner" @click="onBannerClicked">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    onBannerClicked: {
      type: Function,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.banner {
  background-color: $riseup_yellow;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  box-shadow: 0px 5px 8px rgba(186, 188, 191, 0.25);
  cursor: pointer;
}
</style>
